import {Link, useNavigate} from "react-router-dom";
import {
    Header,
    Title,
    StepsTable,
    AssistantName,
    BotName,
    Records,
    StyledSpan,
    StepHeader,
    StepRow
} from "../styles/AssistantsPage.styles";

import {PlusLogo, TgLogo} from "@/assets/Logos.tsx";
import { useEffect, useState } from "react";
import { assistantApi } from "@/api/assistants";
import { IAssistant } from "@/types/assistants";
import { Button } from "@/components/ui/Button";
import { SkeletonTable } from "../../components/ui/Loaders/SkeletonTable";
import { useAppDispatch } from "@/hooks/redux.ts";
import { setCurrentAssistant } from "@/store/assistantSlice.ts";

const getRecordsLabel = (count: number) => {
    if (count % 10 === 1 && count % 100 !== 11) {
        return `${count} запись`;
    } else if ((count % 10 >= 2 && count % 10 <= 4) && (count % 100 < 10 || count % 100 >= 20)) {
        return `${count} записи`;
    } else {
        return `${count} записей`;
    }
};

export const AssistantsPage = () => {
    const navigate = useNavigate();
    const [assistants, setAssistants] = useState<IAssistant[] | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useAppDispatch();

    useEffect(() => {
        setIsLoading(true);
        assistantApi.getAll().then((res) => {
            const mappedData = res.data.reduce((acc: IAssistant[], i: IAssistant) => {
                const integrations = JSON.parse(i.Integrations)?.telegram;
                acc.push({
                    ...i,
                    Integrations: integrations
                });
                return acc;
            }, [] as IAssistant[]);
            setAssistants(mappedData);
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);

    return (
        <div>
            <Header>
                <Title>Мои ассистенты</Title>
                <Button variant="blue" padding="10px 25px 10px 19px" onClick={() => navigate('/dashboard/assistants/add')}>
                    <PlusLogo/>
                    <StyledSpan>Добавить ассистента</StyledSpan>
                </Button>
            </Header>
            {isLoading ? <SkeletonTable rows={3} cols={4} /> : (
                <StepsTable>
                    <StepHeader>
                        <div style={{ marginLeft: '16px' }}>Наименование</div>
                        <div style={{ marginLeft: '16px' }}>Интеграции</div>
                        <div style={{ marginLeft: '24px' }}>Файлы и данные</div>
                        <div style={{ marginLeft: '16px' }}>Дата создания</div>
                    </StepHeader>
                    {!assistants?.length ? (
                        <div style={{
                            padding: '20px 16px',
                            color: '#666',
                            fontSize: '14px',
                            textAlign: 'center'
                        }}>
                            Пока нет ассистентов
                        </div>
                    ) : (
                        assistants.map((assistant) => (
                            <StepRow key={assistant.ID}>
                                <AssistantName
                                    onClick={() => dispatch(setCurrentAssistant(assistant))}
                                    style={{ marginLeft: '16px' }}
                                    to= {`/dashboard/assistants/${assistant.ID}/scenarios`}
                                >
                                    {assistant.PictureURL ? (
                                        <img src={assistant.PictureURL} alt="" />
                                    ) : (
                                        <div style={{
                                            width: '25px',
                                            height: '25px',
                                            borderRadius: '50%',
                                            backgroundColor: 'rgb(217, 217, 217)'
                                        }} />
                                    )}
                                    <span style={{fontSize: '14px', fontWeight: '600', color: 'rgb(35, 88, 162)'}}>{assistant.Name}</span>
                                </AssistantName>
                                {assistant.Integrations ? (
                                    <BotName>
                                        <TgLogo />
                                        <Link
                                            onClick={() => dispatch(setCurrentAssistant(assistant))}
                                            style={{ fontWeight: 400 }}
                                            to={`https://t.me/${assistant.Integrations}`}
                                            target='_blank'
                                        >
                                            @{assistant.Integrations}
                                        </Link>
                                    </BotName>
                                ) : (
                                    <div style={{ marginLeft: '16px' }}>Нет интеграций</div>
                                )}
                                <Records to={`/dashboard/assistants/${assistant.ID}/data`}>{getRecordsLabel(assistant.step_count)}</Records>
                                <div style={{marginLeft: '16px'}}>{new Date(assistant.CreatedAt).toLocaleDateString()}</div>
                            </StepRow>
                        )))}
                </StepsTable>
            )}
        </div>
    );
};
